module.exports = __webpack_public_path__ + "static/media/SayfaBaslik_3_IsProgramiListe.5db934f1.png";